import { MenuItem, Stack, Typography } from '@mui/material';
import {
  RHFMultiSelect,
  RHFSearchableMultiSelect,
  RHFSelect,
  RHFTextField,
} from '@Components/hook-form';
import {
  ProviderStatus,
  useGetProvidersFromAllRgsQuery,
  useGetProvidersQuery,
  useGetRolesQuery,
} from '@Src/generated.graphql';
import { useMemo } from 'react';
import { MenuItemEx } from '@Components/shared/selects/MenuItemEx';
import { useAuthorization } from '@Modal/hooks/authorization/useAuthorization';
import { useSetupUserForm } from '@Forms/users/SetupUserFormContext';

const useDropDown = () => {
  const { data: providersData } = useGetProvidersQuery();
  const { data: rolesData } = useGetRolesQuery();

  const roleDropdown = useMemo(
    () =>
      rolesData?.roles?.map(({ name, id }) => (
        <MenuItemEx key={id} value={id} name="Users">
          {name}
        </MenuItemEx>
      )),
    [rolesData]
  );
  const roleOptions = useMemo(
    () =>
      rolesData?.roles?.map(({ name, id }) => ({
        label: name,
        value: id,
      })) || [],
    [rolesData]
  );
  const providersDropdown = useMemo(
    () =>
      providersData?.providers?.map(({ name, id }) => (
        <MenuItemEx key={name} value={id} name="Users">
          {name}
        </MenuItemEx>
      )),
    [providersData]
  );

  return {
    roles: roleDropdown,
    roleOptions,
    providers: providersDropdown,
  };
};

export const UserDrawerDetails = () => {
  const { currentUser } = useAuthorization();
  const dropdown = useDropDown();
  const { data } = useGetProvidersFromAllRgsQuery();
  // const { data } = useGetProvidersFromAllRgsQuery();
  const methods = useSetupUserForm();
  const isSuper = currentUser?.isSuper;

  return (
    <Stack direction="column" spacing={2} margin={2}>
      {/* <RHFMultiSelect
        name="games"
        label="games"
        variant="outlined"
        chip
        options={[
          { label: 'Aviator', value: 1 },
          { label: 'Mines', value: 2 },
        ]}
      ></RHFMultiSelect> */}
      {isSuper && (
        <RHFSelect label="Is Provider Users Admin" name="isProviderUsersAdmin" variant="outlined">
          <MenuItem value="true">True</MenuItem>
          <MenuItem value="false">False</MenuItem>
        </RHFSelect>
      )}
      {isSuper && (
        <RHFMultiSelect
          name="allowedRoleIds"
          label="Allowed role ids"
          variant="outlined"
          chip
          options={dropdown.roleOptions}
          disabled={methods.watch('isProviderUsersAdmin') === 'false'}
        ></RHFMultiSelect>
      )}
      <RHFTextField name="email" label="Email" type="email" />
      {/* <RHFTextField name="password" label="Password" />
      <Stack>
        <Typography variant="caption" sx={{ color: 'grey' }}>
          Length: min - 8, recommended - 14
        </Typography>
        <Typography variant="caption" sx={{ color: 'grey' }}>
          Complexity: min - 1 uppercase, 1 lowercase, 1 number, 1 symbol
        </Typography>
        <Typography variant="caption" sx={{ color: 'grey' }}>
          Disallowed pattern: Username
        </Typography>
      </Stack> */}
      <RHFSelect label="Role" name="roleIds" variant="outlined">
        {dropdown.roles}
      </RHFSelect>
      <RHFSearchableMultiSelect name="providerRgs" providers={data?.providersFromAllRGS || []} />
    </Stack>
  );
};
